<template>
  <search-modal 
    title="Clientes"
    :url="url"
    :show="show"
    :custom-filters="custom"
    :filters-bar="filtersBar"
    :search-on-create="searchOnCreate"
    :persistent="true"
    @change-search="$emit('change-search', $event)"
    @change-value="$emit('change-value', $event)">
    <template slot="list" slot-scope="{items, filters, highlight}">
      <template v-for="(item, i) in items">
        <v-list-tile
          :key="`customer-list-${i}`"
          @click="$emit('selected', { customer: item })"
          avatar>
          <v-list-tile-avatar>
            <v-icon class="k-orange-linear-text" large>
              fas fa-user
            </v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="f1-2em word-wrap k-grey-light-text "
              v-html="highlight(item.name || `${item.first_name} ${item.last_name}`)">
              </span>
            </v-list-tile-title>
            <v-list-tile-title v-if="filters.filter !== 'name'">
              <span class="f1em word-wrap k-grey-light-text">
                <!-- <span v-if="['phone', 'email'].includes(filters.filter)"
                v-html="highlight(getFirstContact(item, filters))">
                </span>
                <span v-else
                v-html="highlight(item[filters.filter])">
                </span> -->
                <span
                  v-if="!['phone', 'email'].includes(filters.filter)"
                  v-html="highlight(item[filters.filter])">
                </span>
              </span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider
          v-if="i !== items.length - 1"
          :key="`divider${i}`">
        </v-divider>
      </template>
    </template>
  </search-modal>
</template>
<script>
import SearchModal from '@/components/global/SearchModalV2';
import { mapGetters } from 'vuex';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    searchOnCreate: {
      type: Boolean,
      default: false,
    },
    customFilters: {
      type: Array,
      default: () => [],
    },
    fromChatCenter: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SearchModal,
  },
  computed: {
    ...mapGetters([
      'customerStatuses',
    ]),
    custom() {
      const custom = [
        {
          name: 'Estados',
          valueText: 'id',
          nameFilter: 'status',
          items: [
            {
              name: 'Estados',
              id: null,
            },
            ...this.customerStatuses,
          ],
        },
      ];
      custom.push(...this.customFilters);
      return custom;
    },
    url() {
      if (this.fromChatCenter) {
        return 'customers/v2/chat_center';
      }
      return 'customers/v2';
    },
  },
  data() {
    return {
      filtersBar: [
        {
          name: 'Nombre',
          value: 'name',
        },
        {
          name: 'RUT/DNI/CI',
          value: 'fiscal_id',
        },
        {
          name: 'Cuenta',
          value: 'account',
        },
        {
          name: 'Email',
          value: 'email',
        },
        {
          name: 'Teléfono',
          value: 'phone',
        },
      ],
    };
  },
  methods: {
    getFirstContact(item, filters) {
      const contacts = item[`customer_${filters.filter}s`];
      if ((contacts || []).length) {
        return contacts[0][filters.filter];
      }
    },
  }
};
</script>
<style scoped>
.scroll {
  height: 385px;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/SearchCustomer.vue